import { apiFetch } from '../utils/api';

export interface ComplimentaryReason {
  id: string;
  erpId: number;
  reason: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedComplimentaryReasonsResponse {
  data: ComplimentaryReason[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

interface FetchComplimentaryReasonsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const fetchComplimentaryReasons = (
  params: FetchComplimentaryReasonsParams = {},
): Promise<PaginatedComplimentaryReasonsResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.search) {
    searchParams.set('search', params.search);
  }

  const query = searchParams.toString();
  return apiFetch<PaginatedComplimentaryReasonsResponse>(
    `/complimentary-reasons${query ? `?${query}` : ''}`,
  );
};
